import React from 'react';

export type LoadingVariant = 'page' | 'embedded';

type LoadingIndicatorProps = {
    /** `page` fills the main column; `embedded` for widgets, tables, and partial UI. */
    variant?: LoadingVariant;
};

const LoadingIndicator = ({ variant = 'page' }: LoadingIndicatorProps) => (
    <div
        className={
            variant === 'embedded'
                ? 'loading-container loading-container--embedded'
                : 'loading-container'
        }
    >
        <div className="main-loading-spinner"></div>
        <p className="loading-text">Loading...</p>
    </div>
);

export default LoadingIndicator;
